import CampaignStatus from '@/models/Campaigns/CampaignStatus';

export default class CampaignStatusViewModel {
    name: string;
    value: CampaignStatus;

    public constructor(name: string, value: CampaignStatus) {
        this.name = name;
        this.value = value;
    }
}